"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLink = exports.abstractLinkProps = void 0;
const composition_api_1 = require("@vue/composition-api");
const _composables_1 = require("../../_composables");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.abstractLinkProps = {
    ..._composables_1.canBeDisabledProp,
    /**
     * The link to render.
     */
    link: {
        type: Object,
        required: true
    }
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.useLink = (props) => {
    /**
     * Value for the `[target]` attribute of the `<a>` element.
     */
    const aTarget = composition_api_1.computed(() => {
        return props.link.newTab ? '_blank' : '_self';
    });
    /**
     * Determines whether the passed-in `link` prop has a valid `target` property.
     */
    const hasCorrectTarget = composition_api_1.computed(() => {
        const target = props.link.target;
        if (typeof target === 'undefined') {
            return false;
        }
        if (typeof target === 'object' && target === null) {
            return false;
        }
        // noinspection RedundantIfStatementJS
        if (typeof target === 'string' && target.length === 0) {
            return false;
        }
        return true;
    });
    const external = composition_api_1.computed(() => {
        const target = props.link.target;
        const toCheck = typeof target !== 'string' ? `${target.path}` : target;
        return props.link.isExternal || toCheck.toLowerCase().startsWith('http://') || toCheck.toLowerCase().startsWith('https://');
    });
    const rel = composition_api_1.computed(() => {
        const rels = new Set();
        if (props.link.nofollow)
            rels.add('nofollow');
        if (props.link.sponsored)
            rels.add('sponsored');
        if (props.link.rel)
            props.link.rel.split(' ').forEach(rel => rels.add(rel));
        return Array.from(rels).join(' ') || undefined;
    });
    return {
        aTarget,
        hasCorrectTarget,
        external,
        rel,
        label: composition_api_1.computed(() => props.link.label),
        target: composition_api_1.computed(() => props.link.target)
    };
};
//# sourceMappingURL=Link.hooks.js.map